import { useState } from 'react'
import DownloadIcon from '@mui/icons-material/Download'
import EditIcon from '@mui/icons-material/Edit'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import UploadIcon from '@mui/icons-material/Upload'
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'

import { useEditConfig } from '@providers/EditConfigProvider'

import { CONFIG_MENU_OPTION, CONFIG_MENU_TITLES } from '@constants'

type EditConfigMenuProps = {
  configId?: string | number
}

export const EditConfigMenu = ({ configId }: EditConfigMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const { configMenuOption, handleSelectConfigMenuOption, setIsOpenScriptDialog } = useEditConfig()

  const open = Boolean(anchorEl)

  const handleSelect = (option: CONFIG_MENU_OPTION | null) => {
    if (option === CONFIG_MENU_OPTION.IMPORT) {
      setIsOpenScriptDialog(true)
    }
    handleSelectConfigMenuOption?.(option, configId)
    handleClose()
  }

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => setAnchorEl(null)

  return (
    <Box
      sx={theme => ({
        mx: 2,
        border: theme.palette.border.field,
        borderRadius: 1,
        alignItems: 'center',
        maxHeight: 40,
      })}
    >
      <IconButton size='medium' onClick={handleOpen}>
        <MoreVertIcon fontSize='small' />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={open}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              minWidth: 160,
              '& .MuiMenuItem-root': { fontSize: 14 },
            },
          },
        }}
        onClose={handleClose}
      >
        <MenuItem
          selected={configMenuOption === CONFIG_MENU_OPTION.EXPORT}
          onClick={() => handleSelect(CONFIG_MENU_OPTION.EXPORT)}
        >
          <ListItemIcon>
            <UploadIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText primary={CONFIG_MENU_TITLES[CONFIG_MENU_OPTION.EXPORT]} />
        </MenuItem>

        {!configId && (
          <MenuItem
            selected={configMenuOption === CONFIG_MENU_OPTION.IMPORT}
            onClick={() => handleSelect(CONFIG_MENU_OPTION.IMPORT)}
          >
            <ListItemIcon>
              <DownloadIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary={CONFIG_MENU_TITLES[CONFIG_MENU_OPTION.IMPORT]} />
          </MenuItem>
        )}

        <MenuItem
          selected={configMenuOption === CONFIG_MENU_OPTION.EDIT}
          onClick={() => handleSelect(CONFIG_MENU_OPTION.EDIT)}
        >
          <ListItemIcon>
            <EditIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText primary={CONFIG_MENU_TITLES[CONFIG_MENU_OPTION.EDIT]} />
        </MenuItem>
      </Menu>
    </Box>
  )
}
